"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable no-nested-ternary */

/* eslint-disable no-param-reassign */

var moment_1 = __importDefault(require("moment"));

exports.moment = moment_1.default;
var Ordinal;

(function (Ordinal) {
  Ordinal["th"] = "th";
  Ordinal["st"] = "st";
  Ordinal["nd"] = "nd";
  Ordinal["rd"] = "rd";
})(Ordinal = exports.Ordinal || (exports.Ordinal = {}));

var ordinalMap = (_a = {}, _a[Ordinal.nd] = "ⁿᵈ", _a[Ordinal.rd] = "ʳᵈ", _a[Ordinal.st] = "ˢᵗ", _a[Ordinal.th] = "ᵗʰ", _a);

var ordinal = function ordinal(num) {
  var b = num % 10;
  var output = // eslint-disable-next-line no-bitwise
  ~~(num % 100 / 10) === 1 ? Ordinal.th : b === 1 ? Ordinal.st : b === 2 ? Ordinal.nd : b === 3 ? Ordinal.rd : Ordinal.th;
  return num + "[" + output + "]";
};

moment_1.default.updateLocale("en", {
  ordinal: ordinal
});
moment_1.default.updateLocale("us", {
  ordinal: ordinal
});

var overwriteOrdinalPlaceholder = function overwriteOrdinalPlaceholder(date) {
  var keys = Object.keys(Ordinal);
  var ordinalKey = keys.find(function (key) {
    return date.includes("[" + key + "]");
  });

  if (ordinalKey) {
    return date.replace("[" + ordinalKey + "]", ordinalMap[ordinalKey]);
  }

  return date;
};

exports.overwriteOrdinalPlaceholder = overwriteOrdinalPlaceholder;